import React,{useState,useEffect} from 'react';
import HaederDesktop from '../assets/images/header-d.png';
import HaederMobile from '../assets/images/header-m.png';
import Data from '../data/personalities.json';
import {useHistory} from "react-router";
import {Link} from "react-router-dom";
import Header from "./header";
import Footer from "./footer";



function Home() {

    const [currentActive, setActive] = useState(null);
    const [currentAd, setAd] = useState(Math.floor(Math.random() * 2));

    let history = useHistory();

    useEffect(()=>{
        setInterval(()=>{
            setAd(Math.floor(Math.random() * 2));
        },30 *1000);
    },[])

    function getAd(item){
        const random = currentAd;     // returns a random integer from 0 to 9

        return(
            <div className={"personality "+ item.classname}><div className={item.classname+"__inner"}>
            <a href={item.link[random]}><img src={require('../assets/images/'+ item.thumbs[random]).default} /></a>
        </div></div>
        );
    }


    return (
        <>
        <Header/>
        <main>
            {Data.map((item, index)=>{
                return (
                    <>
                    {item.type && item?.type === 'filler' ?
                        <>
                        {item.view && item.view === 'rotate' ?
                            <>
                            {getAd(item)}
                            </>
                        :
                        <div className={"personality "+ item.classname}><div className={item.classname+"__inner"}>
                            <a href={item.link}><img src={require('../assets/images/'+ item.thumb).default} /></a>
                        </div></div>
                        }
                        </>
                    :
                    <div className={"personality" + (currentActive && item.id != currentActive ? " personality__blur": "" )}
                         onMouseEnter={()=>{
                             setActive(item.id);
                         }} onMouseLeave={()=>{
                        setActive(null);
                    }}
                    >
                        <Link to={'/40under40_2020/'+item.id}>
                        <div className={"personality__image"}>
                            <img src={require('../assets/images/personalities/thumbs/'+item.thumb).default}/>
                        </div>
                        <div className={"personality__name"}>{item.name}</div>
                        <div className={"personality__career"}>{item.title}</div>
                        </Link>
                    </div>}
                    </>
                );
            })}
        </main>
        <Footer />
        </>
    );
}

export default Home;
